// deno-fmt-ignore-file
import { Object } from '../../types/object.mjs';
export function FromBooleanKey(value) {
    return Object({ true: value, false: value });
}
